module.exports = __webpack_public_path__ + "static/logo-ce5116ad173547f23167f0fb34fa68be.svg";